var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"modalHeaderNotification",attrs:{"value":_vm.alertVisible,"type":_vm.alertType,"dismissible":_vm.isDismissible},on:{"input":_vm.setVisible}},[_vm._v(" "+_vm._s(_vm.$t(_vm.alertText))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }